import { useState } from 'react';
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline';
import { IconButton } from './ui';
import { generateInsightsPDF, generateComparisonPDF } from '../utils/pdfGenerator';

export default function PDFExport({
  companyData,
  comparisonData,
  type = 'insights',
  className = ''
}) {
  const [isGenerating, setIsGenerating] = useState(false);

  const handleExport = async () => {
    setIsGenerating(true);

    try {
      let result;

      if (type === 'insights') {
        result = await generateInsightsPDF(companyData.name);
      } else if (type === 'comparison') {
        result = await generateComparisonPDF(companyData, comparisonData);
      }

      if (result.success) {
        // Success notification could be added here
        console.log('PDF generated successfully:', result.fileName);
      } else {
        // Error notification could be added here
        console.error('PDF generation failed:', result.error);
        alert('Failed to generate PDF. Please try again.');
      }
    } catch (error) {
      console.error('Error exporting PDF:', error);
      alert('Failed to generate PDF. Please try again.');
    } finally {
      setIsGenerating(false);
    }
  };

  return (
    <IconButton
      icon={ArrowDownTrayIcon}
      label={isGenerating ? 'Generating PDF...' : 'Download as PDF'}
      variant="primary"
      size="md"
      display="icon"
      onClick={handleExport}
      disabled={isGenerating || !companyData}
      className={className}
    />
  );
}
